<template>
  <base-dialog
    :action="onAction"
    :action-name="'Apply to account balance'"
    :cancel-name="'Cancel'"
    :close="onClose"
    :title="'Customer balance adjustment'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-container>
        <v-row
          class="text-center"
        >
          <v-col cols="6">
            <span>Starting Balance</span><br>
            <span
              v-money="{ amount: balanceModel, currency: model.currency}"
              class="headline"
            />
          </v-col>
          <v-divider vertical />
          <v-col cols="5">
            <span>New Balance</span><br>
            <span class="headline">{{ newBalance }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              dense
              outlined
              v-model="adjustmentType"
              label="Adjustment type"
              :items="adjustmentTypes"
              item-value="id"
              item-text="name"
            />
            <amount-input
              :init-amount="parseInt(model.amount, 10)"
              @change="val => { model.amount = val }"
            />

            <currency-select
              v-if="!currency"
              disabled
              :init="model.currency"
              @change="(val) => { model.currency = val }"
            />

            <v-textarea
              v-model="model.description"
              outlined
              label="Add internal note"
              persistent-hint
              hint="This space can be used to provide additional information about your adjustment. This is an internal note and will not be visible to your customer."
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import { formatMoney } from "../../services/util.service"
import AmountInput from "../Common/AmountInput"
import CurrencySelect from "../Common/CurrencySelect"

export default {
  components: { CurrencySelect, AmountInput, BaseDialog },
  props: {
    id: {  // customer id
      type: String,
      default: ''
    },
    currency: {
      type: String,
      default: ''
    },
    balance: {
      type: Number,
      default: 0.00
    },
  },
  mounted() {
    if (this.currency) {
      this.model.currency = this.currency
    }

  },
  data() {
    return {
      model: {
        amount: 0.00,
        currency: 'cad', // default for now
        description: ''
      },
      balanceModel: this.balance,
      adjustmentType: 'credit',
      adjustmentTypes: [
        {
          id: 'credit',
          name: 'Credit'
        },
        {
          id: 'debit',
          name: 'Debit'
        }
      ]
    }
  },
  computed: {
    newBalance() {
      const value = this.isCredit()
        ? (parseInt(this.balanceModel, 10) - parseInt(this.model.amount, 10))
        : (parseInt(this.balanceModel, 10) + parseInt(this.model.amount, 10))


      if (value === this.balanceModel || isNaN(value)) {
        return '----'
      }
        return formatMoney({ amount: value, currency: this.model.currency})

    }
  },
  watch: {
    balance() {
      this.balanceModel = this.balance
    }
  },
  methods: {
    ...mapActions([ 'createCustomerBalance' ]),
    onClose() {
      this.$emit('close')
    },
    isCredit(){
      return this.adjustmentType === 'credit'
    },
    startingBalance() {
      return this.balanceModel > 0
        ? `$${this.balanceModel}`
        : `($${this.balanceModel * -1})`
    },
    onAction() {
      const amount = this.isCredit() ? this.model.amount * -1 : this.model.amount

      const payload = {
        customer: this.id,
        ...this.model,
        amount
      }

      return this.createCustomerBalance(payload)
        .then(balance => {
          this.balanceModel = balance.ending_balance
          this.amount = 0.00
          this.$emit('action', balance)
        })
    }
  }
}
</script>
